import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-bootstrap.css";
import {
  getAgentInfo,
  selectAgentInfo
} from "../../../state/ducks/member/index";

class AgentInfo extends Component {
  componentDidMount() {
    this.props.getAgentInfo();
  }

  render() {
    const { agent } = this.props;
    return (
      <div className="container-fluid">
        {/* Yeşil Alan*/}
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            {/* KUTU 1 */}
            <div className="row no-gutters t-kutu t-mavicizgi">
              <div
                className="col bosluk backright"
                style={{
                  backgroundImage:
                    'url("/assets/img/backgrounds/back_right_mavi.jpg")'
                }}
              >
                {/* içerikler */}
                {/* Başlık */}
                <div className="row no-gutters pb-4">
                  <div clss="col-auto">
                    <i className="t-icon-user-tie  icon" />
                  </div>
                  <div className="col d-flex flex-column justify-content-center">
                    <div className="baslik">Temsilci Bilgileri</div>

                    <Link to="/Home/AskToAgent" className="t-icButonTrunucu" >

                      <span>Temsilcime Sor</span>
                      <i className="t-icon-arrow-right2" />
                    </Link>
                  </div>
                </div>
                {/* Ad soyad satır */}
                <div className="row no-gutters pt-4">
                  <div className="col-12 satirOzellikleri">
                    <span className="maviBaslik">Adı Soyadı</span>
                    <span>{agent.temsilci}</span>
                  </div>
                  <div className="col-12 t-hr">
                    
                  </div>
                </div>
                {/* Ad soyad satır */}

                {agent.iletisimList &&
                  agent.iletisimList.map(item => {
                    return (
                      <div className="row no-gutters" key={item.tip}>


                        <div className="col-12 satirOzellikleri" >

                          <span className="maviBaslik">{item.tip}</span>
                          <span>{item.bilgi}</span>

                        </div>
                        <div className="col-12 t-hr">
                         
                        </div>
                      </div>
                    );
                  })}

                {/* içerikler BİTTİ */}
              </div>
              <div className="col-auto renk" />
            </div>
            {/* KUTU 1 BİTTİ */}


            {/* KUTU 1 */}
            <div className="row no-gutters t-kutu t-yesilCizgi"  hidden={ agent?.musteriHizmetleriYetkilileri === null || agent?.musteriHizmetleriYetkilileri?.length === 0 }>
              <div className="col bosluk backtop" style={{
                backgroundImage:
                  'url("/assets/img/backgrounds/back_top_yesil.jpg")'
              }}>
                {/* içerikler */}
                {/* Başlık */}
                <div className="row no-gutters pb-4">
                  <div clss="col-auto">
                    <i className="t-icon-users icon" />
                  </div>
                  <div className="col d-flex flex-column justify-content-center">
                    <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                      Müşteri Operasyon Yetkilileri
                    </div>
                    {/* <span className="altBaslik">Onaylı Referanslarım</span> */}
                  </div>
                </div>
                <div className="row no-gutters">
                
                  {/* Tablo*/}
                  <div className="col-12 table-responsive">

                    <table className="table table-sm t-tablo text-left">
                        <thead>
                          <tr>
                            <th scope="col">Ad Soyad</th>
                            <th scope="col">E-Posta</th>
                            <th scope="col">Telefon</th>

                          </tr>
                        </thead>
                        <tbody>
                          {agent?.musteriHizmetleriYetkilileri &&
                            agent?.musteriHizmetleriYetkilileri.map((item, index) => {
                              
                              return (
                                <tr key={item.telefon + '_' + index}>
                                  <td>{item.adSoyad}</td>
                                  <td>{item.eposta}</td>
                                  <td>{item.telefon}</td>
                                </tr>
                              );
                            })}
                          
                        </tbody>
                      </table>
                  </div>
                </div>
                {/* içerikler BİTTİ */}
              </div>
              <div className="col-auto renk" />
            </div>
            {/* KUTU 1 BİTTİ */}


            {/* KUTU 2 */}
            <div className="row no-gutters t-kutu t-turuncuCizgi">
              <div
                className="col bosluk backright"
                style={{
                  backgroundImage:
                    'url("/assets/img/backgrounds/back_right_turuncu.jpg")'
                }}
              >
                {/* içerikler */}
                {/* Başlık */}
                <div className="row no-gutters pb-4">
                  <div clss="col-auto">
                    <i className="t-icon-phone2 icon" />
                  </div>
                  <div className="col d-flex flex-column justify-content-center">
                    <div className="baslik">Şube İletişim Bilgileri</div>
                    <span className="altBaslik"> {agent.sube?.subeAdi}</span>
                  </div>
                </div>
                {/* Şube Telefonu */}
                <div className="row no-gutters pt-4">
                  <div className="col-12 satirOzellikleri">
                    <span className="maviBaslik">Şube Telefonu</span>
                    <span> {agent.sube?.telefon1}</span>
                  </div>
                  <div className="col-12 t-hr">
                    
                  </div>
                </div>
                {/* Şube Fax */}
                <div className="row no-gutters pt-4">
                  <div className="col-12 satirOzellikleri">
                    <span className="maviBaslik">Şube Fax</span>
                    <span>{agent.sube?.fax1}</span>
                  </div>
                  <div className="col-12 t-hr">
                   
                  </div>
                </div>
                {/* mail */}
                <div className="row no-gutters">
                  <div className="col-12 satirOzellikleri">
                    <span className="maviBaslik">Şube Mail</span>
                    <span>{agent.sube?.email1}</span>
                  </div>
                  <div className="col-12 t-hr">
                   
                  </div>
                </div>
                {/* Adres */}
                <div className="row no-gutters">
                  <div className="col-12 satirOzellikleri">
                    <span className="maviBaslik">Şube Adresi</span>
                    <span>
                      {agent.sube?.adres}{" "}
                    </span>
                  </div>
                  <div className="col-12 t-hr">
                   
                  </div>
                </div>
                {/* Adres İlçe */}
                <div className="row no-gutters">
                  <div className="col-12 satirOzellikleri">
                    <span className="maviBaslik">Şube İlçesi</span>
                    <span>{agent.sube?.ilce}</span>
                  </div>
                  <div className="col-12 t-hr">
                   
                  </div>
                </div>
                {/* Adres Şehir */}
                <div className="row no-gutters">
                  <div className="col-12 satirOzellikleri">
                    <span className="maviBaslik">Şube Şehri</span>
                    <span>{agent.sube?.sehir}</span>
                  </div>
                  <div className="col-12 t-hr">
                   
                  </div>
                </div>
                {/* Adres Ülke */}
                <div className="row no-gutters">
                  <div className="col-12 satirOzellikleri">
                    <span className="maviBaslik">Şube Ülkesi</span>
                    <span>{agent.sube?.ulke}</span>
                  </div>
                </div>
                {/* içerikler BİTTİ */}
              </div>
              <div className="col-auto renk" />
            </div>
            {/* KUTU 2 BİTTİ */}
          </div>
        </div>
        <div className="row" style={{ height: 30 }} />
      </div>

    );
  }
}

const mapStateToProps = state => {
  return {
    agent: selectAgentInfo(state)
  };
};

const mapDispatchToProps = dispatch => ({
  getAgentInfo: () => dispatch(getAgentInfo())
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentInfo);
